import {
  StatsigProvider as SP,
  useClientAsyncInit
} from '@statsig/react-bindings'
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics'
import { StatsigSessionReplayPlugin } from '@statsig/session-replay'

import { useAuth } from './AuthContext'

interface StatsigProviderProps {
  children: React.ReactNode
}

export function StatsigProvider({ children }: StatsigProviderProps) {
  const { user } = useAuth()

  const { client } = useClientAsyncInit(
    process.env.STATSIG_CLIENT_KEY,
    { userID: user.id },
    {
      plugins: [
        new StatsigAutoCapturePlugin(),
        new StatsigSessionReplayPlugin()
      ]
    }
  )

  return <SP client={client}>{children}</SP>
}
